export const formatFileSize = (sizeInBytes: number): string => {
    if (sizeInBytes < 1024) {
      return `${sizeInBytes} B`; // Bytes
    } else if (sizeInBytes < 1024 * 1024) {
      return `${(sizeInBytes / 1024).toFixed(2)} KB`; // KB
    } else {
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`; // MB
    }
  };
